import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shopping-bag-4"><path d="M3.75 7.75H20.25V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 8.25V7C7.75 4.65279 9.65279 2.75 12 2.75C14.3472 2.75 16.25 4.65279 16.25 7V8.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconShoppingBag4;
